<template>
  <v-container fluid>
    <v-row v-for="(item, index) in items" :key="index" class="pb-4">
      <v-col cols="12" md="2">
        <input-handler
          :path="`${path}[${index}].size`"
          :addRules="[(v) => !!v || 'This field is required.']"
        />
      </v-col>
      <v-col cols="12" md="1">
        <input-handler
          :path="`${path}[${index}].bay`"
          :options="options"
          :addRules="[(v) => !!v || 'This field is required.']"
        />
      </v-col>
      <v-col cols="12" md="2">
        <input-handler
          :path="`${path}[${index}].offset`"
          :addRules="[(v) => !!v || 'This field is required.']"
          :setValue="
            item.centered.value
              ? centeredWidth(item.bay.value, item.size.value)
              : item.offset.value
          "
        />
      </v-col>
      <v-col cols="12" md="2">
        <input-handler :path="`${path}[${index}].accessories.window`" />
      </v-col>
      <v-col cols="12" md="5">
        <input-handler
          :path="`${path}[${index}].accessories.options`"
          :multiple="true"
        />
      </v-col>
      <v-col cols="12" md="2">
        <input-handler :path="`${path}[${index}].centered`" />
      </v-col>
    </v-row>
    <v-row class="pa-4">
      <v-col>
        <v-btn small color="accent" @click="addWalkDoor(type, buildingIndex)"
          >Add</v-btn
        >
      </v-col>
      <v-col v-if="items.length > 0">
        <v-btn
          small
          color="secondary"
          @click="removeWalkDoor(type, buildingIndex)"
          >Remove
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex"
export default {
  name: "WalkDoor",

  props: {
    items: Array,
    type: String,
  },

  data: () => ({ bayWidths: [] }),

  computed: {
    ...mapState({
      buildings: (state) => state.data.buildings,
      activeTab: (state) => state.form.activeTab,
    }),
    buildingIndex() {
      return this.$route.params.buildingIndex
    },
    path() {
      return `buildings[${this.buildingIndex}].${this.type}.walkDoors`
    },
    leftEndwallWalkDoors() {
      return this.buildings[this.buildingIndex].leftEndwall.walkDoors
    },
    rightEndwallWalkDoors() {
      return this.buildings[this.buildingIndex].rightEndwall.walkDoors
    },
    frontSidewallWalkDoors() {
      return this.buildings[this.buildingIndex].frontSidewall.walkDoors
    },
    backSidewallWalkDoors() {
      return this.buildings[this.buildingIndex].backSidewall.walkDoors
    },
    leftEndwallPath() {
      return `buildings[${this.buildingIndex}].leftEndwall`
    },
    rightEndwallPath() {
      return `buildings[${this.buildingIndex}].rightEndwall`
    },
    frontSidewallPath() {
      return `buildings[${this.buildingIndex}].frontSidewall`
    },
    backSidewallPath() {
      return `buildings[${this.buildingIndex}].backSidewall`
    },
    leftEndwallMirrored() {
      return this.buildings[this.buildingIndex].leftEndwall.mirroredWalkDoors
    },
    rightEndwallMirrored() {
      return this.buildings[this.buildingIndex].rightEndwall.mirroredWalkDoors
    },
    frontSidewallMirrored() {
      return this.buildings[this.buildingIndex].frontSidewall.mirroredWalkDoors
    },
    backSidewallMirrored() {
      return this.buildings[this.buildingIndex].backSidewall.mirroredWalkDoors
    },
    tab() {
      return this.activeTab
    },
    options() {
      const surface =
        this.buildings[this.buildingIndex][this.type].surfaceSpacings
      const options = []
      let bays = 0
      if (surface.length > 0) {
        surface.forEach((bay) => {
          if (bay.numberOfBays.value !== "")
            bays = bays + parseInt(bay.numberOfBays.value)
        })
        surface.map((bay) => {
          for (let i = 0; i < bay.numberOfBays.value; i++) {
            this.bayWidths.push(parseFloat(bay.width.value))
          }
        })
      }
      for (let i = 0; i < bays; i++) {
        let bay = i + 1
        const option = {
          display: bay,
          value: bay,
        }
        options.push(option)
      }
      return options
    },
  },

  components: {
    InputHandler: () =>
      import(
        /* webpackChunkName: 'InputHandler' */
        "@/components/input/InputHandler"
      ),
  },

  watch: {
    leftEndwallMirrored: {
      deep: true,
      handler() {
        if (
          this.type === "leftEndwall" &&
          this.leftEndwallMirrored.value !== this.rightEndwallMirrored.value
        ) {
          this.updateStateValue({
            object: this.rightEndwallMirrored,
            value: this.leftEndwallMirrored.value,
            path: `${this.rightEndwallPath}.mirroredWalkDoors`,
          })
          if (this.leftEndwallMirrored.value) {
            const leftEndwallClone = JSON.parse(
              JSON.stringify(this.leftEndwallWalkDoors)
            )
            this.setObject({
              object: leftEndwallClone,
              path: this.rightEndwallPath,
              value: "walkDoors",
            })
          }
        }
      },
    },
    leftEndwallWalkDoors: {
      deep: true,
      handler() {
        if (this.leftEndwallMirrored.value && this.tab === 1) {
          const leftEndwallClone = JSON.parse(
            JSON.stringify(this.leftEndwallWalkDoors)
          )
          this.setObject({
            object: leftEndwallClone,
            path: this.rightEndwallPath,
            value: "walkDoors",
          })
        }
      },
    },
    rightEndwallMirrored: {
      deep: true,
      handler() {
        if (
          this.type === "rightEndwall" &&
          this.leftEndwallMirrored.value !== this.rightEndwallMirrored.value
        ) {
          this.updateStateValue({
            object: this.leftEndwallMirrored,
            value: this.rightEndwallMirrored.value,
            path: `${this.leftEndwallPath}.mirroredWalkDoors`,
          })
          if (this.rightEndwallMirrored.value) {
            const rightEndwallClone = JSON.parse(
              JSON.stringify(this.rightEndwallWalkDoors)
            )
            this.setObject({
              object: rightEndwallClone,
              path: this.leftEndwallPath,
              value: "walkDoors",
            })
            this.updateValue = true
          }
        }
      },
    },
    rightEndwallWalkDoors: {
      deep: true,
      handler() {
        if (this.leftEndwallMirrored.value && this.tab === 3) {
          const rightEndwallClone = JSON.parse(
            JSON.stringify(this.rightEndwallWalkDoors)
          )
          this.setObject({
            object: rightEndwallClone,
            path: this.leftEndwallPath,
            value: "walkDoors",
          })
        }
      },
    },
    backSidewallMirrored: {
      deep: true,
      handler() {
        if (
          this.type === "backSidewall" &&
          this.frontSidewallMirrored.value !== this.backSidewallMirrored.value
        ) {
          this.updateStateValue({
            object: this.frontSidewallMirrored,
            value: this.backSidewallMirrored.value,
            path: `${this.frontSidewallPath}.mirroredWalkDoors`,
          })
          if (this.backSidewallMirrored.value) {
            const backSidewallClone = JSON.parse(
              JSON.stringify(this.backSidewallWalkDoors)
            )
            this.setObject({
              object: backSidewallClone,
              path: this.backSidewallPath,
              value: "walkDoors",
            })
            this.updateValue = true
          }
        }
      },
    },
    backSidewallWalkDoors: {
      deep: true,
      handler() {
        if (this.frontSidewallMirrored.value && this.tab === 4) {
          const backSidewallClone = JSON.parse(
            JSON.stringify(this.backSidewallWalkDoors)
          )
          this.setObject({
            object: backSidewallClone,
            path: this.frontSidewallPath,
            value: "walkDoors",
          })
        }
      },
    },
    frontSidewallMirrored: {
      deep: true,
      handler() {
        if (
          this.type === "frontSidewall" &&
          this.backSidewallMirrored.value !== this.frontSidewallMirrored.value
        ) {
          this.updateStateValue({
            object: this.backSidewallMirrored,
            value: this.frontSidewallMirrored.value,
            path: `${this.backSidewallPath}.mirroredWalkDoors`,
          })
          if (this.frontSidewallMirrored.value) {
            const frontSidewallClone = JSON.parse(
              JSON.stringify(this.frontSidewallWalkDoors)
            )
            this.setObject({
              object: frontSidewallClone,
              path: this.frontSidewallPath,
              value: "walkDoors",
            })
            this.updateValue = true
          }
        }
      },
    },
    frontSidewallWalkDoors: {
      deep: true,
      handler() {
        if (this.backSidewallMirrored.value && this.tab === 2) {
          const frontSidewallClone = JSON.parse(
            JSON.stringify(this.frontSidewallWalkDoors)
          )
          this.setObject({
            object: frontSidewallClone,
            path: this.backSidewallPath,
            value: "walkDoors",
          })
        }
      },
    },
  },

  methods: {
    ...mapActions({
      updateStateValue: "data/updateStateValue",
      setObject: "data/setObject",
      addValidWalkDoor: "data/addWalkDoorToArray",
      removeValidWalkDoor: "data/removeWalkDoorFromArray",
    }),
    async addWalkDoor(type, buildingIndex) {
      await this.addValidWalkDoor({ type, buildingIndex })
    },
    removeWalkDoor(type, buildingIndex) {
      this.removeValidWalkDoor({ type, buildingIndex })
    },
    centeredWidth(bay, width) {
      let bays = JSON.parse(JSON.stringify(this.bayWidths))
      if (this.type === "rightEndwall" || this.type === "backSidewall")
        bays.reverse()
      if (bay !== "") {
        const sizeWidth = width.substring(0, 1)
        const offset = bays[bay - 1] / 2 - sizeWidth / 2
        return offset.toFixed(4).toString()
      }
      return "0"
    },
  },
}
</script>
